import SectionHero from "../inner-page/sectionHero";
import SectionDiscount from "../inner-page/sectionDiscount";
import SectionTips from "../inner-page/sectionTips";
import SectionCta from "../inner-page/sectionCta";
import SectionSmsTips from "../inner-page/sectionSmsTips";
import "../../css/innerPage.scss";

const AfterPage = (props) => {
  return (
    <>
      <main className={`inner-page ${props.color}`}>
        <SectionHero {...props.hero} />
        {props.discount.display_section && <SectionDiscount {...props.discount} />}
        {props.tips.display_section && <SectionTips {...props.tips} />}
        {props.cta.display_section && <SectionCta {...props.cta} />}
        {props.sms_tips.display_section && <SectionSmsTips {...props.sms_tips} />}
      </main>
    </>
  );
};

export default AfterPage;
